// removed by extract-text-webpack-plugin
module.exports = {"button":"GmFzA","isMuted":"_2XS2B"};


//////////////////
// WEBPACK FOOTER
// ./app/components/header-button/header-button.scss
// module id = 1579
// module chunks = 0